import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';


import {
  entityTecnicosAdapter,
  EntityTecnicosState
} from './entity-tecnicos.state';
import { selectAuthPersona } from '../../persona/entity-personas/entity-personas.selectors';

const { selectEntities, selectAll } = entityTecnicosAdapter.getSelectors();

export const getError = (state: EntityTecnicosState): any => state.error;

export const getIsLoading = (state: EntityTecnicosState): boolean =>
  state.isLoading;

export const selectTecnicosState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.tecnicos
);

export const selectAllTecnicos = createSelector(selectTecnicosState, selectAll);
export const selectEntitiesTecnicos = createSelector(
  selectTecnicosState,
  selectEntities
);

//
// export const selectAllRol = createSelector(selectRolState, selectAll);
// export const selectEntitiesRol = createSelector(selectRolState, selectEntities);

export const selectAuthTecnicos = createSelector(
  selectAllTecnicos, selectAuthPersona,
  (tecnicos, persona) => tecnicos.filter(t => t.persona_id === persona.id)
)

// MemoizedSelector<object,any>
export const selectTecnicosError = createSelector(
  selectTecnicosState,
  getError
);

// MemoizedSelector<object,any>
export const selectTecnicosIsLoading = createSelector(
  selectTecnicosState,
  getIsLoading
);
